exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Button {\n  padding: 0;\n  border: none;\n  margin-left: 10px; }\n\n.LogoButton .icon {\n  fill: #e6e6e6; }\n\n.LogoButton:hover .icon {\n  fill: #b3d4d6; }\n\n.LogoButton_size_small,\n.LogoButton_size_small svg {\n  width: 20px;\n  height: 20px; }\n\n.LogoButton_size_medium,\n.LogoButton_size_medium svg {\n  width: 30px;\n  height: 30px; }\n\n.LogoButton_size_large,\n.LogoButton_size_large svg {\n  width: 40px;\n  height: 40px; }\n", ""]);

// exports
